import type { JobDashboardPublicationStatus } from 'generated/graphql'

type ChipStatusType = 'draft' | 'done'

const statusMap: Record<string, ChipStatusType> = {
  draft: 'draft',
  locked_grid: 'done',
  locked_grid_and_data: 'done',
  default: 'draft',
}

export function mapBriefingStatus(publicationStatus?: JobDashboardPublicationStatus | null): ChipStatusType {
  return statusMap[publicationStatus ?? 'default'] || statusMap.default
}
